/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Filter, NewsItems } from '../models/news';

export enum ActionTypes {
  InitNewsItems = '[HOMEPAGE] init news items',
  GetNewsItems = '[HOMEPAGE] get news items',
  GetNewsItemsSuccess = '[HOMEPAGE] get news items success'
}

export class InitNewsItems implements Action {
  readonly type = ActionTypes.InitNewsItems;
  constructor(public payload: Filter) {}
}

export class GetNewsItems implements Action {
  readonly type = ActionTypes.GetNewsItems;
  constructor(public payload: Filter) {}
}

export class GetNewsItemsSuccess implements Action {
  readonly type = ActionTypes.GetNewsItemsSuccess;
  constructor(public payload: { newsItems: NewsItems; filter: any }) {}
}

export type Actions = InitNewsItems | GetNewsItems | GetNewsItemsSuccess;
